import de from './de'
import en from './en'
import es from './es'
import fr from './fr'
import it from './it'
import nl from './nl'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const messages = {
  de: de,
  en: en,
  es: es,
  fr: fr,
  it: it,
  nl: nl,
}

const i18n = new VueI18n({
  fallbackLocale: 'en',
  locale: 'de',
  messages,
})

export default i18n
